<template>
	<a-tabs defaultActiveKey="1">
	  <a-tab-pane key="1" tab="课程评价分类维护">
	    <CourseEvaluationCategoryManagementPage />
	  </a-tab-pane>
	  <a-tab-pane key="2" tab="课程评价设置">
	    <CourseEvaluationParameterConfigurationPage />
	  </a-tab-pane>
	  <a-tab-pane key="3" tab="教师评价规则设定">
	    <TeacherEvaluationRuleSettingPage />
	  </a-tab-pane>
	  <a-tab-pane key="4" tab="参评学生资格限定">
	    <EligibleStudentRestrictionPage />
	  </a-tab-pane>
	  <a-tab-pane key="5" tab="评价相关教学班配置">
	    <TeachingClassConfigurationPage />
	  </a-tab-pane>
	  <a-tab-pane key="6" tab="学生评级条件设定">
	    <StudentRatingConditionSettingPage />
	  </a-tab-pane>
	  <a-tab-pane key="7" tab="听课教师任务分配">
	    <ClassroomObservationTeacherTaskAssignmentPage />
	  </a-tab-pane>
	</a-tabs>
</template>

<script>
	// 引入组件
	import CourseEvaluationCategoryManagementPage from './modules/CourseEvaluationCategoryManagementPage.vue';
	import CourseEvaluationParameterConfigurationPage from './modules/CourseEvaluationParameterConfigurationPage.vue';
	import TeacherEvaluationRuleSettingPage from './modules/TeacherEvaluationRuleSettingPage.vue';
	import EligibleStudentRestrictionPage from './modules/EligibleStudentRestrictionPage.vue';
	import TeachingClassConfigurationPage from './modules/TeachingClassConfigurationPage.vue';
	import StudentRatingConditionSettingPage from './modules/StudentRatingConditionSettingPage.vue';
	import ClassroomObservationTeacherTaskAssignmentPage from './modules/ClassroomObservationTeacherTaskAssignmentPage.vue';
	
	export default {
	  name: 'App',
	  components: {
	    CourseEvaluationCategoryManagementPage,
	    CourseEvaluationParameterConfigurationPage,
	    TeacherEvaluationRuleSettingPage,
	    EligibleStudentRestrictionPage,
	    TeachingClassConfigurationPage,
	    StudentRatingConditionSettingPage,
	    ClassroomObservationTeacherTaskAssignmentPage
	  }
	};
</script>

<style>
</style>